import {
  applyMiddleware,
  legacy_createStore as createStore,
  type Middleware,
  type Reducer,
  type Store,
} from 'redux';
import { thunk } from 'redux-thunk';

const defaultReducer: Reducer = (state = {}): Record<string, unknown> => state;

/**
 * Creates a minimal Redux store with Thunk middleware.
 *
 * This function initializes a Redux store using the provided reducer and initial state.
 * It applies `redux-thunk` middleware to support asynchronous actions.
 *
 * @param {Reducer} [reducer=defaultReducer] - The root reducer for the store. Defaults to an empty reducer.
 * @param {Object} [initialState={}] - The initial state of the store.
 * @param {Middleware[]} [extraMiddleware=[]] - Optional array of additional middleware.
 * @returns {Store} A Redux store configured with the provided reducer, initial state, and thunk middleware.
 */
function getMinimalStore(
  reducer: Reducer = defaultReducer,
  initialState: object = {},
  extraMiddleware: Middleware[] = []
): Store {
  return createStore(
    reducer,
    initialState,
    applyMiddleware(thunk, ...extraMiddleware)
  );
}

export default getMinimalStore;
